import { Tag, Tooltip } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import type { PerformanceStatus } from "./types"

const COLORS: Record<PerformanceStatus, string> = {
  attention: "red",
  watch: "orange",
  good: "green",
  insufficient: "default"
}

interface Props {
  status: PerformanceStatus
  reasons: string[]
}

// Colour is never the only signal: the label is text and the reasons are
// spoken and shown on hover (spec §2 "Attention status", §7 Accessibility).
export function StatusTag({ status, reasons }: Props) {
  const { t } = useTranslation()
  const label = t(`teamPerformance.status.${status}`)
  const reasonText = reasons
    .map((r) => t(`teamPerformance.reasons.${r}`))
    .join("; ")
  return (
    <Tooltip title={reasonText || undefined}>
      <span tabIndex={reasonText ? 0 : undefined}>
        <Tag color={COLORS[status]} bordered={false}>
          {label}
        </Tag>
        {reasonText && <span className="sr-only">{reasonText}</span>}
      </span>
    </Tooltip>
  )
}
